
import React, {useEffect, useReducer, useState} from "react";
import {HgCakeSummary} from "./HgCakeSummary";
import HgCakeChoices from "./HgCakeChoices";
import HgCakeDisplay from "./HgCakeDisplay";
import {Layers} from "./Layers";
import {addCake, currency} from "./Helper";
import {submitCart} from "../shop/actions";
import BorderBox from "./BorderBox";
import {nanoid} from "nanoid";


const initialCake = {
    size: null,
    flavor: null,
    finish: null,
    decor: null
};

const cakeReducer = (state, action) => {
    let next = state;
    switch (action.type) {
        case 'loaded':
            return action.payload;
        case 'update':
            const update = {};
            update[action.group] = action.value;
            next = Object.assign({}, state, update);
            break;
    }
    return next;
}

function NoteField({updateCake, cake}) {
    return <div className={"hg-cake-note"}>
        <div className={"hg-cake-note-inner"}>
            <h2>Anmerkung</h2>
            <textarea rows={"3"}
                      value={cake.note}
                      placeholder={"Ihre Anmerkung an uns für Ihre Torte"}
                      onChange={(e) => updateCake("note", e.target.value)} />
        </div>
    </div>
}

function normalizeCake(cake) {
    if (!cake) {
        cake = initialCake;
    }
    if (!cake.id) {
        cake.id = nanoid();
    }
    return cake;
}

export default function HgCake({id, cakeData}) {
    const [isEdit, setIsEdit] = useState(cakeData !== undefined);

    const [config, setConfig] = useState(null);
    const [cake, cakeDispatch] = useReducer(cakeReducer, normalizeCake(cakeData));
    const [fatalError, setFatalError] = useState(false);
    const [currentGroup, setCurrentGroup] = useState('size');
    const [dirty, setDirty] = useState(false);
    const [loading, setLoading] = useState(true);
    const [addedToCart, setAddedToCart] = useState(false);

    const setGroup = (group) => {
        setCurrentGroup(group === currentGroup ? false : group);
    }

    const updateCake = (group, value) => {
        setDirty(true);
        setAddedToCart(false);
        cakeDispatch({
            type: 'update',
            group: group,
            value: value
        });
    }

    const addToCart = () => {
        setLoading(true);
            addCake(cake, config)
            .done(() => {
                setDirty(false);
                setAddedToCart(true);
                setLoading(false);
            }).fail((err) => {
                console.log("ERR");
            });
    }

    useEffect(() => {
        fetch('/wp-json/hg/v1/cake/' + id).then((r) => {
            return r.json();
        }).then((data) => {
            setConfig(data);
            setLoading(false);
        }).catch((err) => {
            setFatalError(err);
        });

    }, []);

    if (config === null) {
        return <div className="hg-react-container hg-react-loading"></div>;
    }

    if (fatalError !== false) {
        return <div>fatal error: {fatalError}</div>;
    }

    return <div className={"hg-cake-editor-wrapper"}>
        <HgCakeDisplay currentGroup={currentGroup} config={config} cake={cake} />
        <HgCakeChoices currentGroup={currentGroup} setCurrentGroup={setGroup} isLoading={loading} isDirty={dirty} config={config} cake={cake} updateCake={updateCake} />
        <HgCakeSummary
            isEdit={isEdit}
            isLoading={loading}
            isDirty={dirty}
            isAddedToCart={addedToCart}
            addToCart={addToCart}
            config={config}
            cake={cake}
            setCurrentGroup={setGroup}
            currentGroup={currentGroup}
        />
            {!loading && <NoteField updateCake={updateCake} config={config} cake={cake} />}
    </div>;
}


// WEBPACK FOOTER //
// ./js/cake/HgCake.js